import styles from './RequestedTherapist.module.css'
// import InfoIcon from '../Icons/InfoIcon'
import StarIcon from '../Icons/StarIcon'
import CheckSquareIcon from '../Icons/CheckSquareIcon'

export const RequestedTherapist = ({ compact = false }) => {
  return (
    <div className={styles.requestedTherapist}>
        {!compact && <CheckSquareIcon/>}
        <StarIcon/>
        Requested Therapist
        {/* {!compact && <InfoIcon/>} */}
    </div>
  )
}
